module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXRewardsTank/components/Footer/images/icon_ok.5b66330c.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXRewardsTank/components/Footer/images/icon_ok.png
// module id = 1046
// module chunks = 16